import { trackEvent } from './trackEvent';
import { OPEN_DEDUPE_MS } from '@services/tracking/config';
// used for 'opened' events instead of simple trackEvent() with 3 seconds deduplication
// to prevent spamming one event action;
const recentOpenEvents = new Map<string, number>();

export const trackOpenedEvent = (eventName: string, props: Record<string, unknown> = {}): void => {
  const itemKey =
    props.machineId ??
    props.ncFileId ??
    props.productionBatchId ??
    props.productionOperationId ??
    props.partId ??
    props.recipeId ??
    props.recipeOperationId ??
    props.toolId ??
    props.documentId ??
    props.productionOrderId ??
    'noItem';

  const dedupeKey = `${eventName}:${itemKey}`;
  const now = Date.now();
  const lastTrackedAt = recentOpenEvents.get(dedupeKey);

  if (lastTrackedAt && now - lastTrackedAt < OPEN_DEDUPE_MS) {
    return;
  }

  recentOpenEvents.set(dedupeKey, now);

  // Prune old entries to prevent unbounded growth
  if (recentOpenEvents.size > 200) {
    for (const [key, timestamp] of recentOpenEvents) {
      if (now - timestamp > OPEN_DEDUPE_MS * 3) {
        recentOpenEvents.delete(key);
      }
    }
  }

  trackEvent(eventName, {
    ...props,
    action: 'opened',
  });
};
